import { FC } from 'react';
import { Tr } from '@utils';
import { SimulationTask } from '@services';
import { Grid, Typography } from '@mui/material';
import { EntityList, EntityListItem, EntityListItemCell, IEntityListProps } from '@components/common';

type EntityType = SimulationTask;

export interface IWizardVehicleListProps extends IEntityListProps<EntityType> {
	paddingX?: number | string;
	entities: EntityType[];
	selected: EntityType[];
	onSelectChange?: (selected: EntityType[]) => void;
}

export const WizardVehicleList: FC<IWizardVehicleListProps> = ({ entities, selected, onSelectChange, paddingX, ...props }) => {
	const handleSelectChange = (status: boolean, entity: EntityType) => {
		const newSelections = selected.filter((s) => s.id !== entity.id);
		status && newSelections.push(entity);
		onSelectChange?.(newSelections);
	};

	return (
		<EntityList entities={entities} selected={selected} onSelectChange={onSelectChange} paddingX={paddingX} {...props}>
			{entities.map((entity, i) => (
				<EntityListItem
					key={`entity-${entity.id}-${i}`}
					sx={{ paddingRight: paddingX }}
					selected={!!selected.find((s) => s.id === entity.id)}
					onSelectChange={(status) => handleSelectChange(status, entity)}
				>
					<Grid container columnSpacing={2}>
						<Grid item xs={3}>
							<EntityListItemCell title={<Tr.Portal path="wizard.vehicle-selection.plate-no" />}>
								<Typography>{entity.fleetVehicle?.plateNumber || '-'}</Typography>
							</EntityListItemCell>
						</Grid>
						<Grid item xs={3}>
							<EntityListItemCell title={<Tr.Portal path="wizard.vehicle-selection.current-car" />}>
								<Typography>{entity.conversionListTableCurrentCar.join(', ')}</Typography>
							</EntityListItemCell>
						</Grid>
						<Grid item xs={3}>
							<EntityListItemCell title={<Tr.Portal path="wizard.vehicle-selection.final-selection" />}>
								<Typography>
									{[entity.conversionListTableEvSelection[0]?.brand, entity.conversionListTableEvSelection[0]?.model]
										.filter(Boolean)
										.join(' ') || '-'}
								</Typography>
							</EntityListItemCell>
						</Grid>
						<Grid item xs={3}>
							<EntityListItemCell title={<Tr.Portal path="wizard.vehicle-selection.year" />}>
								<Typography>{entity.electrificationYear || '-'}</Typography>
							</EntityListItemCell>
						</Grid>
					</Grid>
				</EntityListItem>
			))}
		</EntityList>
	);
};
